import React from "react";
import {Link} from "react-router-dom";
import { Image } from "react-bootstrap";
import SearchBoxDesktop from "./SearchBoxDesktop";
import MobileDropdown from "./MobileDropdown";
import DesktopMenu from "./DesktopMenu";
import logo from "../../logo.png";

import { useGetMeQuery } from "../../redux/api/userApi";
import { useSelector } from "react-redux";

import { useNavigate } from "react-router-dom";
import { useLogoutMutation } from "../../redux/api/authApi";

const Header = () => {

  const navigate = useNavigate();

   const [logout] = useLogoutMutation();

 const { isLoading } = useGetMeQuery();

  const { user } = useSelector((state) => state.auth);
     const { cartItems } = useSelector((state) => state.cart);
  
  const logoutHandler = async () => {
    await logout();
    navigate(0);
  };

  

 const currentUser = {
   isSignedIn: user ? true : false,
   name: user?.name,
   avatar: user?.avatar ? user.avatar.url : "/img/default_avatar.jpg",
 };

  return (
    <nav className="custom-navbar">
      <header className="creatyea-padding">
        <Link className="custom-navbar-brand" to="/">
          <Image src={logo} alt="Creatyea" />
        </Link>
        <SearchBoxDesktop />
        <div className="d-flex flex-row align-items-center">
          <Link to="/cart" className="custom-navbar-cart">
            <>
              {cartItems.length > 0 ? (
                <span className="cart-item-count">{cartItems.length}</span>
              ) : (
                <span className="cart-item-count">0</span>
              )}
            </>
            <Image src="/img/cart.png" alt="Cart" />
          </Link>

          <div className="nav dropdown custom-navbar-item custom-dropdown">
            {currentUser.isSignedIn ? (
              <>
                <button
                  className="btn dropdown-toggle"
                  type="button"
                  id="dropDownMenuButton"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <figure className="avatar avatar-nav">
                    <img
                      src={currentUser?.avatar}
                      alt="User Avatar"
                      className="rounded-circle"
                    />
                  </figure>
                  <span className="super">{currentUser?.name}</span>
                </button>

                <div
                  className="dropdown-menu custom-dropdown-menu"
                  aria-labelledby="dropDownMenuButton"
                >
                  <Link
                    className="custom-dropdown-item blue-color"
                    to="/me/profile"
                  >
                    {" "}
                    My Profile{" "}
                  </Link>

                  <Link
                    className="custom-dropdown-item blue-color"
                    to="/me/orders"
                  >
                    {" "}
                    Orders{" "}
                  </Link>

                  <Link
                    className="custom-dropdown-item blue-color"
                    to="/me/quotes"
                  >
                    {" "}
                    My Quotes{" "}
                  </Link>

                  <Link
                    className="custom-dropdown-item blue-color"
                    to="/me/update_profile"
                  >
                    {" "}
                    Update Profile{" "}
                  </Link>

                  <Link
                    className="custom-dropdown-item blue-color"
                    to="/"
                    onClick={logoutHandler}
                  >
                    {" "}
                    Sign Out{" "}
                  </Link>
                </div>
              </>
            ) : (
              !isLoading && (
                <Link to="/login" className="btn dropdown-toggle text-white">
                  <span className="mr-2">Sign in/up</span>
                  <i className="fas fa-caret-down"></i>
                </Link>
              )
            )}
          </div>
        </div>
        <MobileDropdown />
      </header>
      <DesktopMenu />
    </nav>
  );
};

export default Header;
